import BylineList from 'components/Byline';
import type { TagNewsletter } from 'interfaces/Taxonomy';
import { setEventAction } from 'utils/trackDataUtils';
import { ContentTitle } from 'components/ContentTitle';
import CustomLink from 'components/Globals/Base/Link';
import RightRailFlex from 'components/Ad/AdSlot/RightRailFlex';
import ADS_TEST_IDS from 'constants/testsIds/ads';
import { NEWSLETTERS_TEST_IDS } from 'constants/testsIds/homepage';
import { Container, Item, List, Wrapper } from './NewsletterClassicBlockStyles';

export interface NewsletterClassicBlockProps {
  heading: string;
  items: TagNewsletter[];
  adIndex: number;
  className?: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const NewsletterClassicBlock = ({ heading, items, adIndex, className }: NewsletterClassicBlockProps) => (
  <Wrapper
    className={className}
    data-cy={NEWSLETTERS_TEST_IDS.NEWSLETTERS}
  >
    <Container>
      {heading && (
        <ContentTitle
          className='heading'
          font='saolText'
          tag='h2'
          dataCy={NEWSLETTERS_TEST_IDS.TITLE}
        >
          {heading}
        </ContentTitle>
      )}
      <List>
        {items.map((item) => {
          const tagTrackingData = {
            contentPlacementCD: heading,
            eventAction: setEventAction(item.articleEyebrowSectionLabel, item.articleEyebrowTagLabel),
            eventCategory: item.articleEyebrowSectionLabel,
            eventLabel: `category click : ${item.articleDescription}`,
          };

          const titleTrackingData = {
            contentPlacementCD: heading,
            eventAction: setEventAction(item.articleEyebrowSectionLabel, item.articleEyebrowTagLabel),
            eventCategory: item.articleEyebrowSectionLabel,
            eventLabel: `title click : ${item.articleDescription}`,
          };

          return (
            <Item
              key={item.tagSlug + item.articleUri}
              data-cy={NEWSLETTERS_TEST_IDS.ARTICLE}
            >
              <CustomLink
                href={item.tagSlug}
                className='tag'
                trackingData={tagTrackingData}
                ariaLabel={`Go to article's tag page ${item.articleEyebrowTagLabel}`}
                dataCy={NEWSLETTERS_TEST_IDS.SECTION_TITLE}
              >
                {item.name}
              </CustomLink>
              <CustomLink
                href={item.articleUri}
                className='description'
                trackingData={titleTrackingData}
                ariaLabel={`Go to article's full page ${item.name}`}
                dataCy={NEWSLETTERS_TEST_IDS.ARTICLE_TITLE}
              >
                {item.articleDescription}
              </CustomLink>
              <BylineList
                bylineList={item.articleAuthors}
                className='authors'
                trackingData={{ ...titleTrackingData, eventLabel: item.articleDescription }}
              />
            </Item>
          );
        })}
      </List>
    </Container>
    {items.length > 3 && (
      <RightRailFlex
        id={adIndex}
        dataCy={`${ADS_TEST_IDS.RIGHT_RAIL_FLEX}-${adIndex}`}
      />
    )}
  </Wrapper>
);

export default NewsletterClassicBlock;
